import {gql} from '@apollo/client';

export const CREATE_REG = gql`
    mutation createOnlyCashReg ($data: OnlyCashRegInput!, $session: String) {
        createOnlyCashReg(data: $data, session: $session) {
            data {
                id
            }
        }
    }
`

export const CREATE_CODE = gql`
    mutation createOnlyCashCode ($data: OnlyCashCodeInput!, $phone: String!) {
        createOnlyCashCode(data: $data, phone: $phone) {
            data {
                id
            }
        }
    }
`

export const CHECK_CODE = gql`
    mutation checkOnlyCashCode ($data: CheckOnlyCashCodeInput!, $session: String) {
        checkOnlyCashCode(data: $data, session: $session) {
            FIO
            token
            paid
        }
    }
`

export const QUERY_ME = gql`
    query onlyCashMe ($token: String!) {
        onlyCashMe(token: $token) {
            FIO
            paid
        }
    }
`